import React from 'react';
import { Calendar as MuiCalendar, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Moment } from 'moment';
import { Grid, withStyles, StyledComponentProps } from '@material-ui/core';
import ConfirmButton from '../../../../ui-components/Button/ConfirmButton';
import UndoButton from '../../../../ui-components/Button/UndoButton';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import { styles } from './styles';

interface IProps {
    onCancel: () => any;
    onConfirm: (date: Date) => any
}
const CalendarComp = (props: IProps & StyledComponentProps) => {
    const [date, setDate] = React.useState<Moment>(moment());
    const confirm = () => {
        props.onConfirm(date.toDate());
    }
    return (
        <Grid container className={props.classes.CalendarContainer}>
            <Grid item sm={12} className={props.classes.CalendarContainer}>
                <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale='it'>
                    <MuiCalendar onChange={date => setDate(date)} date={date} />
                </MuiPickersUtilsProvider>
            </Grid>
            <Grid item sm={12} className={props.classes.CalendarButtonsContainer}>
                <ConfirmButton text='Conferma' onClick={confirm} />
                <UndoButton text='Annulla' onClick={() => props.onCancel()} />
            </Grid>
        </Grid>)
}

export const Calendar = withStyles(styles)(CalendarComp)